<div class="e-generic-modal">
    <h1 class="e-dialog-title">
        <i class="{{ data.iconClass }}"></i>
        {{ data.title }}
    </h1>
    <div class="e-dialog-content">
        <p>{{ data.content }}</p>
    </div>
    <div [ngClass]="{'e-dialog-actions-primary': data.buttons.primary && !data.buttons.secondary, 'e-dialog-actions-primary-secondary': data.buttons.primary && data.buttons.secondary }" class="e-dialog-actions">
        <button *ngIf="data.buttons.secondary" mat-button color="secondary" [mat-dialog-close]="false" (click)="onClick()">
            {{ data.buttons.secondary }}
        </button>
        <button mat-button color="primary" [mat-dialog-close]="true" (click)="onClick()">
            {{ data.buttons.primary }}
        </button>
    </div>
    <div *ngIf="data.showUnderstoodCheckbox" class="e-understood-checkbox">
        <mat-checkbox [(ngModel)]="isUnderstoodChecked" >I understand, dont show this message again</mat-checkbox>
    </div>
</div>
